import { OrderActivityType } from 'types/OrderActivityTypes.enum'

export function shouldDisplayAsByBoralAccordingToType(type: OrderActivityType) {
  return [
    OrderActivityType.ORDER_PROCESSING,
    OrderActivityType.ORDER_ACCEPTED,
    OrderActivityType.ORDER_MODIFICATION_PROCESSING,
    OrderActivityType.ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT,
    OrderActivityType.ORDER_MODIFICATION_REJECTED,
    OrderActivityType.ORDER_PLUS_LOAD_APPLIED,
    OrderActivityType.ORDER_PLUS_LOAD_REJECTED,
  ].includes(type)
}
